module.exports = __webpack_public_path__ + "img/chesya-burke.ab749afa.png";